// extracted by mini-css-extract-plugin
var _1 = "InfiniteScrollWaypoint-module__loader--iB1uX";
var _2 = "InfiniteScrollWaypoint-module__waypoint--_OSVu";
export { _1 as "loader", _2 as "waypoint" }
